// src/url.js
export default {
    // user apis
    user: {
      login: '/user/login',
      logout: '/user/logout/',
    },
    // categories apis
    categories: {
        get: 'categories/',
        post: 'categories/', 
        update: 'categories/:pk/', 
    },
    // sub categories apis
    sub_categories: {
      get: 'sub_categories/',
      post: 'sub_categories/', 
      update: 'sub_categories/:pk/', 
    },
    // item size api's
    item_size: {
        get: 'item_size/',
        post: 'item_size/',
        update: 'item_size/:pk/',
    },
    // item color api's
    item_color: {
        get: 'item_color/',
        post: 'item_color/',
        update: 'item_color/:pk/',
    },
    // inventory store api's
    inventory_store: {
        get: 'inventory_store/',
        post: 'inventory_store/',
        update: 'inventory_store/:pk/',
    },
    // inventory warehouse api's
    inventory_warehouse: {
        get: 'inventory_warehouse/',
        post: 'inventory_warehouse/',
        update: 'inventory_warehouse/:pk/',
    },
    // inventory supplier api's
    inventory_supplier: {
        get: 'inventory_supplier/',
        post: 'inventory_supplier/',
        update: 'inventory_supplier/:pk/',
        import_sample: 'inventory_supplier/import/sample/',
        import_preview: 'inventory_supplier/import/preview/',
        import_validate: 'inventory_supplier/import/validate/',
        import_confirm: 'inventory_supplier/import/confirm/',
        export: 'inventory_supplier/export/',
    },
    // measurement unit api's
    measurement_unit: {
        get: 'measurement_unit/',
        post: 'measurement_unit/',
        update: 'measurement_unit/:pk/',
    },
    // item api's
    item: {
        get: 'item/',
        post: 'item/',
        update: 'item/:pk/',
        variants: 'item/:item_id/variants/',
        lifecycle: 'item/:item_id/lifecycle/',
        batches: 'item/:item_id/batches/',
        all_variants: 'variants/',
        variant_update: 'item/variants/:pk/',
        import_sample: 'item/import/sample/',
        import_preview: 'item/import/preview/',
        import_validate: 'item/import/validate/',
        import_confirm: 'item/import/confirm/',
        export: 'item/export/',
    },
    backup: {
        export: 'backup/export/',
    },

    // income head api's
    income_head: {
        get: 'income_cat/',
        post: 'income_cat/',
        update: 'income_cat/:pk/',
    },

    income_head_sub: {
        get: 'income_sub_cat/',
        post: 'income_sub_cat/',
        update: 'income_sub_cat/:pk/',
    },

    expense_head: {
        get: 'expense_head/',
        post: 'expense_head/',
        update: 'expense_head/:pk/',
    },

    expense_sub_head: {
        get: 'expense_sub_head/',
        post: 'expense_sub_head/',
        update: 'expense_sub_head/:pk/',
    },

    supplier_head: {
        get: 'supplier_head/',
        post: 'supplier_head/',
        update: 'supplier_head/:pk/',
    },

    supplier_sub_head: {
        get: 'supplier_sub_head/',
        post: 'supplier_sub_head/',
        update: 'supplier_sub_head/:pk/',
    },

    customer_head: {
        get: 'customer_head/',
        post: 'customer_head/',
        update: 'customer_head/:pk/',
    },

    customer_sub_head: {
        get: 'customer_sub_head/',
        post: 'customer_sub_head/',
        update: 'customer_sub_head/:pk/',
    },

    bank_account_head: {
        get: 'bank_account_head/',
        post: 'bank_account_head/',
        update: 'bank_account_head/:pk/',
    },

    item_search: {
        get: 'search_item/'
    },

    serialized_units: {
        get: 'serialized-units/'
    },

    pos_pay: {
       post: 'pos/payment/'
    },

    inv_batch: {
        get: 'batches/',
        post: 'batch/create/'
    },

    batch_cash_type: {
        get: 'batch/cash/type/',
    },

    batch_item_search: {
        get: 'batch/item/search/',
    },

    batch_receive_no: {
        get: 'batch/receive/number/',
    },

    batch_bank_account: {
        get: 'batch/bank/account/',
    },

    pos_new_invoice: {
        get: 'pos/new/invoice/',
    },

    customers: {
        get: 'customers/',
        post: 'customers/',
        update: (id) => `customers/${id}/`,
        import_sample: 'customers/import/sample/',
        import_preview: 'customers/import/preview/',
        import_validate: 'customers/import/validate/',
        import_confirm: 'customers/import/confirm/',
        export: 'customers/export/',
    },

    customer_search: {
        get: 'customer/search/'
    },

    inv_discount_policy: {
        get: 'inv_discount_policy/',
    },

    inv_vat_policy: {
        get: 'inv_vat_policy/',
    },

    inv_invoice_style: {
        get: 'inv_invoice_style/',
    },

    inv_selling_price_policy: {
        get: 'inv_selling_price_policy/',
    },

    inv_invoice_rounding_policy: {
        get: 'inv_invoice_rounding_policy/',
    },

    setting: {
        get: 'setting/',
        update: (id) => `setting/${id}/`,
    },

    payment_type: {
        get: 'payment/type/'
    },

    digital_payment_type: {
        get: 'payment/digital/type/'
    },

    customer_due: {
        get: 'customer/due/'
    },

    customer_due_receive_number: {
        get: 'customer/due/receive/number/'
    },

    customer_payment: {
        post: 'customer/due/payment/',
        get: 'customer/due/payment/'
    },

    supplier_due_receive_number: {
        get: 'supplier/due/receive/number/'
    },

    supplier_search: {
        get: 'supplier/search/'
    },

    supplier_due: {
        get: 'supplier/due/'
    },

    supplier_payment: {
        post: 'supplier/due/payment/',
        get: 'supplier/due/payment/'
    },

    damage_receive_number: {
        get: 'damage/receive/number/'
    },

    damage_item: {
      get: 'damage/item/',
      post: 'damage/item/'
    },

    store_transfer_number: {
        get: 'store/transfer/number/'
    },

    store_transfer: {
        get: 'store/transfer/',
        post: 'store/transfer/',
        respond: 'store/transfer/:id/:action/',
        document: 'store/transfer/document/',
    },

    voucher_search: {
        get: 'voucher/search/'
    },

    voucher_item_search: {
        get: 'voucher/item/search/'
    },

    return_receive_number: {
        get: 'return/receive/number/'
    },

    return_item: {
      post: 'return/item/',
      get: 'return/item/'
    },

    // report file urls
    item_return_report: {
      get: 'item/return/report/'
    },

    item_stock_report: {
      get: 'item/stock/report/'
    },

    stock_summary_report: {
      get: 'report/stock-summary/'
    },

    stock_movement_report: {
      get: 'report/stock-movement/'
    },

    stock_transfer_report: {
      get: 'report/stock-transfer/'
    },

    stock_adjustment_report: {
      get: 'report/stock-adjustment/'
    },

    low_stock_report: {
      get: 'report/low-stock/'
    },

    slow_moving_report: {
      get: 'report/slow-moving/'
    },

    expiry_report: {
      get: 'report/expiry/'
    },

    sales_register_report: {
      get: 'report/sales-register/'
    },

    sales_details_report: {
      get: 'report/sales-details/'
    },

    sales_return_report: {
      get: 'report/sales-return/'
    },

    sales_by_product_report: {
      get: 'report/sales-by-product/'
    },

    sales_by_category_report: {
      get: 'report/sales-by-category/'
    },

    sales_by_customer_report: {
      get: 'report/sales-by-customer/'
    },
    customer_due_report: {
      get: 'report/customer-due/'
    },

    payment_methods_report: {
      get: 'report/payment-methods/'
    },

    discount_vat_report: {
      get: 'report/discount-vat/'
    },

    sales_trend_report: {
      get: 'report/sales-trend/'
    },

    purchase_register_report: {
      get: 'report/purchase-register/'
    },

    purchase_details_report: {
      get: 'report/purchase-details/'
    },

    purchase_return_report: {
      get: 'report/purchase-return/'
    },

    supplier_payments_report: {
      get: 'report/supplier-payments/'
    },

    supplier_due_report: {
      get: 'report/supplier-due/'
    },

    supplier_aging_report: {
      get: 'report/supplier-aging/'
    },

    purchase_by_product_report: {
      get: 'report/purchase-by-product/'
    },

    purchase_cost_report: {
      get: 'report/purchase-cost/'
    },

    general_ledger_report: {
      get: 'report/accounting/general-ledger/'
    },

    party_ledger_report: {
      get: 'report/accounting/party-ledger/'
    },

    cash_book_report: {
      get: 'report/accounting/cash-book/'
    },

    day_book_report: {
      get: 'report/accounting/day-book/'
    },

    accounting_trial_balance_report: {
      get: 'report/accounting/trial-balance/'
    },

    profit_loss_report: {
      get: 'report/accounting/profit-loss/'
    },

    accounting_balance_sheet_report: {
      get: 'report/accounting/balance-sheet/'
    },

    equity_changes_report: {
      get: 'report/accounting/equity-changes/'
    },

    audit_trail_report: {
      get: 'report/accounting/audit-trail/'
    },

    inventory_batch_report: {
        get: 'inventory/batch/report/'
    },

    inventory_sell_report: {
        get: 'inventory/sell/report/'
    },

    inventory_buy_report: {
        get: 'inventory/buy/report/'
    },

    inventory_low_stock_report: {
        get: 'inventory/low/stock/report/'
    },

    customers_due_report: {
        get: 'customers/due/report/'
    },

    suppliers_payment_report: {
        get: 'suppliers/payment/report'
    },

    item_warehouse: {
        get: 'item/warehouse/'
    },

    item_warehouse_qty: {
        get: 'item/warehouse/quantity/'
    },

    purchase_return_receive_number: {
        get: 'purchase/return/receive/number/'
    },

    purchase_return: {
        post: 'purchase/return/',
        get: 'purchase/return/'
    },

    purchase_voucher_search: {
        get: 'purchase/voucher/search/'
    },

    purchase_voucher_item_search: {
        get: 'purchase/voucher/item/search/'
    },

    users: {
      get: 'users/',
      post: 'users/create/',
      detail: id => `users/${id}/`,
      update: id => `users/${id}/`,
      delete: id => `users/${id}/`,
    },

    roles: {
      get: 'user/roles/',
      post: 'user/roles/',
      detail: id => `user/roles/${id}/`,
      update: id => `user/roles/${id}/`,
      delete: id => `user/roles/${id}/`,
    },

    cash_amount: {
        get: 'cash/amount/'
    },

    bank_amount: {
        get: 'bank/amount/'
    },

    income_amount: {
        get: 'income/amount/'
    },

    expense_amount: {
        get: 'expense/amount/'
    },

    discount_amount: {
        get: 'discount/amount/'
    },

    pos_receivable_amount: {
        get: 'pos/receivable/amount/'
    },

    vat_payable_amount: {
        get: 'vat/payable/amount/'
    },

    supplier_bill_payable_amount: {
        get: 'supplier/bill/payable/amount/'
    },

    stores: {
        get: 'store/list/'
    },

    discount_campaign: {
        get: 'discount_campaigns/',
        post: 'discount_campaigns/',
        detail: (id) => `discount_campaigns/${id}/`,
        update: (id) => `discount_campaigns/${id}/`,
        activate: (id) => `discount_campaigns/${id}/activate/`,
        pause: (id) => `discount_campaigns/${id}/pause/`,
        cancel: (id) => `discount_campaigns/${id}/cancel/`,
        assignable_items: 'discount_campaigns/assignable-items/',
        preview_line: 'discount_campaigns/preview-line/',
    },

    pos_best_selling: {
        get: 'pos/best/selling/'
    },

    login_user: {
        get: 'user/login/user/'
    },

    vat_group: {
        get: 'vat_group/',
    },

    item_vat: {
        get: 'item/vat/'
    },

    change_password: {
        post: 'change/password/'
    },

    print_barcodes: {
        post: 'print/barcodes/'
    },

    // chart of accounts apis
    chart_of_accounts: {
      get: 'chart_of_accounts/',
      post: 'chart_of_accounts/', 
      update: 'chart_of_accounts/:pk/', 
    },

    transaction_category: {
      get: 'transaction_category/',
      post: 'transaction_category/', 
      update: 'transaction_category/:pk/', 
    },

    journal_voucher_create:{
        post: 'journal/voucher/create/',
    },
    journal_voucher_number:{
        get: 'journal/voucher/number/',
    },
    journal_voucher:{
        get: 'journal/voucher/',
    },
    report_ledger:{
        get: 'report/ledger/',
    },
    report_trial_balance:{
        get: 'report/trial-balance/',
    },
    report_income_expense:{
        get: 'report/income-expense/',
    },
    report_balance_sheet:{
        get: 'report/balance-sheet/',
    },
    purchase_rq_order_number:{
        get:'purchase/rq/order/number/',
    },
    purchase_requisition:{
        get:'purchase/requisition/',
        post:'purchase/requisition/',
    },
    purchase_requisition_items:{
        get:'purchase/requisition/items/',
    },
    purchase_order:{
        get:'purchase/order/',
        post:'purchase/order/',
        items: 'purchase/order/items/'
    },

    invoice_print: {
        get: 'invoice/print/'
    },

    // item type api's
    item_type: {
        get: 'item_type/',
    },

    attribute: {
        get: 'attribute/list/',
        post: 'attribute/create/'
    },

    dashboard_data: {
        get: 'dashboard/data/'
    },

    recent_item: {
        get: 'recent/item/'
    },

    expire_item: {
        get: 'expire/item/'
    },

    chart_data: {
        get: 'dashboard/chart/'
    },

    invoice_setting: {
        post: 'invoice_setting/',
        get: 'invoice_setting/',
        update: (id) => `invoice_setting/${id}/`,
    },

    sales_list: {
      get: 'sales/list/'
    },

};
